package org.tlsys.wc

import org.tlsys.dto.auth.CorePermission

val OWENER = CorePermission.NODE_SERVICE
val PERMISSION_VIEW_DIAGRAM_LIST = "View_Diagram_List"
val PERMISSION_VIEW_SCRIPT_LIST = "View_Script_List"